// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  --box-shadow: none !important;
  box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.0784313725) !important;
}

ion-content {
  --padding-start: 16px;
  --padding-end: 16px;
  --padding-top: 16px;
  --padding-bottom: 16px;
  --background: var(--background-default);
}

.title {
  font-family: AppFontMedium;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: 0;
  vertical-align: middle;
  margin-bottom: 18px;
  color: var(--ion-color-primary);
}

.wrapper {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  height: -moz-fit-content;
  height: fit-content;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(45%, 1fr));
  gap: 16px;
}
.wrapper .item {
  min-height: 165px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 11px;
  border-radius: var(--radius-default);
  background: white;
  border: var(--outline-default);
  cursor: pointer;
}
.wrapper .item ion-img {
  height: 90px;
  object-fit: contain;
  margin-bottom: 10px;
}
.wrapper .item ion-img.default {
  width: 60%;
}
.wrapper .item .name {
  font-family: AppFontSemiBold;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0.02em;
  text-align: center;
  margin-bottom: 3px;
}
.wrapper .item .info {
  margin: 0;
  flex: 1;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: AppFont;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  color: var(--color-grey);
}

.spinner-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/select-category/select-category.page.scss"],"names":[],"mappings":"AAEA;EACC,6BAAA;EACA,mEAAA;AADD;;AAIA;EACC,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,uCAAA;AAFD;;AAKA;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,+BAAA;AAFD;;AAKA;EACC,WAAA;EACA,iBAAA;EACA,cAAA;EACA,wBAAA;EAAA,mBAAA;EAEA,aAAA;EACA,0DAAA;EACA,SAAA;AAHD;AAKC;EACC,iBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,aAAA;EACA,oCAAA;EACA,iBAAA;EACA,8BAAA;EAEA,eAAA;AALF;AAOE;EACC,YAAA;EACA,mBAAA;EAEA,mBAAA;AANH;AAQG;EACC,UAAA;AANJ;AAUE;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AARH;AAWE;EACC,SAAA;EACA,OAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EAEA,wBAAA;AAXH;;AAgBA;EACC,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAbD","sourcesContent":["@use '../../../theme/mixins' as *;\n\nion-header {\n\t--box-shadow: none !important;\n\tbox-shadow: 0px 4px 45px 0px #00000014 !important;\n}\n\nion-content {\n\t--padding-start: 16px;\n\t--padding-end: 16px;\n\t--padding-top: 16px;\n\t--padding-bottom: 16px;\n\n\t--background: var(--background-default);\n}\n\n.title {\n\tfont-family: AppFontMedium;\n\tfont-size: 20px;\n\tline-height: 120%;\n\tletter-spacing: 0;\n\tvertical-align: middle;\n\tmargin-bottom: 18px;\n\tcolor: var(--ion-color-primary);\n}\n\n.wrapper {\n\twidth: 100%;\n\tmax-width: 1000px;\n\tmargin: 0 auto;\n\theight: fit-content;\n\n\tdisplay: grid;\n\tgrid-template-columns: repeat(auto-fill, minmax(45%, 1fr));\n\tgap: 16px;\n\n\t.item {\n\t\tmin-height: 165px;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tpadding: 11px;\n\t\tborder-radius: var(--radius-default);\n\t\tbackground: white;\n\t\tborder: var(--outline-default);\n\t\t// box-shadow: 1px 1px 2.5px 0px #00000029;\n\t\tcursor: pointer;\n\n\t\tion-img {\n\t\t\theight: 90px;\n\t\t\tobject-fit: contain;\n\n\t\t\tmargin-bottom: 10px;\n\n\t\t\t&.default {\n\t\t\t\twidth: 60%;\n\t\t\t}\n\t\t}\n\n\t\t.name {\n\t\t\tfont-family: AppFontSemiBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: 0.02em;\n\t\t\ttext-align: center;\n\t\t\tmargin-bottom: 3px;\n\t\t}\n\n\t\t.info {\n\t\t\tmargin: 0;\n\t\t\tflex: 1;\n\t\t\tword-break: break-word;\n\t\t\tdisplay: -webkit-box;\n\t\t\t-webkit-line-clamp: 2;\n\t\t\t-webkit-box-orient: vertical;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: 0;\n\t\t\tvertical-align: middle;\n\n\t\t\tcolor: var(--color-grey);\n\t\t}\n\t}\n}\n\n.spinner-wrapper {\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
